module.exports = __webpack_public_path__ + "bd5b384f4015e57ab394bf1a0e60b208.svg";